export const removeEmptyFields = <T>(obj: T): T => {
  return Object.entries(obj).reduce(
    (a, [k, v]) => (v ? { ...a, [k]: typeof v === 'string' ? v.trim() : v } : a),
    {} as T
  );
};
